import React, { ReactElement, useEffect, useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import {v4} from 'uuid'
import { strToSlug } from '../../../common_functions'

interface PropsDropdown {
  id: string
  trigger: ReactElement
  menu: Array<ReactElement>
}

interface Props {
  dropdownButton: string
  dropdownDict: { [key: string]: any }
}

export const DropdownRoot = ({ dropdownButton, dropdownDict }: Props) => {
  const [dropdownList, setDropdownList] = useState<ReactElement[]>()
  const id = v4()

  useEffect(() => {
    defDropdownList()
  }, [])

  const defDropdownList = () => {
    let dropdownListAux: ReactElement[] = []
    Object.entries(dropdownDict).map(([key, value]) => {
      dropdownListAux.push(<a href={value}>{key}</a>)
    })

    setDropdownList(dropdownListAux)
  }

  const handleBlurDropdown = (id:string) => {
    setTimeout(() => {
      document.querySelector(`#${id}`)?.classList.add("hidden")
    }, 500);
  }

  return (
    <Dropdown
      id={strToSlug(dropdownButton)}
      trigger={
        <button className="flex items-center gap-1 font-semibold cursor-pointer" onBlur={() => handleBlurDropdown(strToSlug(dropdownButton))}>
          {dropdownButton}{' '}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <rect width="256" height="256" fill="none"></rect>
            <polyline
              points="208 96 128 176 48 96"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="24"
            ></polyline>
          </svg>
        </button>
      }
      menu={dropdownList !== undefined ? dropdownList : []}
    />
  )
}

const Dropdown = ({ trigger, menu, id }: PropsDropdown) => {
  // const navigation = useNavigate();
  const handleOpen = () => {
    document.querySelectorAll('.menu')?.forEach((element) => {
      element.classList.add('hidden')
    })

    let elementId = document.getElementById(id)
    if (elementId?.classList.contains('hidden')) {
      elementId.classList.remove('hidden')
      elementId.classList.add('flex')
    } else {
      elementId?.classList.add('hidden')
    }
  }

  return (
    <div className="dropdown">
      {React.cloneElement(trigger, {
        onClick: handleOpen
      })}
      <ul
        id={id}
        style={{ animation: 'slideUpAndFade 300ms cubic-bezier(0.16, 1, 0.3, 1)' }}
        className="menu hidden absolute mt-2 -ms-4 bg-off-white min-w-[280px] text-black-60 text-lg font-semibold px-6 py-4 rounded-lg shadow-lg flex-col gap-5 will-change-transform-opacity side-top:animate-slide-down side-right:animate-slide-left side-bottom:animate-slide-up side-left:animate-slide-right z-[999]"
      >
        {menu.map((menuItem, index) => (
          <li key={index} className="menu-item">
            {React.cloneElement(menuItem, {
              onClick: () => {
                menuItem.props.to.includes("http") ? window.location.href = menuItem.props.to : window.location.href = (menuItem.props.to)
                // navigation(menuItem.props.to)
              }
            })}
          </li>
        ))}
      </ul>
    </div>
  )
}
